export default {
  monthStringToNumber(month) {
    switch (month) {
      case 'January':
        return 0
      case 'February':
        return 1
      case 'March':
        return 2
      case 'April':
        return 3
      case 'May':
        return 4
      case 'June':
        return 5
      case 'July':
        return 6
      case 'August':
        return 7
      case 'September':
        return 8
      case 'October':
        return 9
      case 'November':
        return 10
      default:
        return 11
    }
  }
}
